import { useEffect, useState } from "react";
import { Container, Typography, Box, Paper, Divider, CircularProgress } from "@mui/material";
import axios from "axios";
import { privacy_policy } from "../ui-common/nodeDetails/ApiConst/Apiconst";
import Axios from "../redux/setupAxios";

const Section = ({ title, children }) => (
  <Box mb={4}>
    <Typography variant="h6" fontWeight={600} gutterBottom>
      {title}
    </Typography>
    <Typography
      variant="body1"
      color="text.secondary"
      lineHeight={1.8}
      dangerouslySetInnerHTML={{ __html: children }}
    />
  </Box>
);

export default function PrivacyPolicy() {
  const [policy, setPolicy] = useState<any>(null);
  const [loading, setLoading] = useState(true);
 const orgId = localStorage.getItem("org_instance_id") 
 const service_id = localStorage.getItem("service_id") 


const fetchPrivacyPolicy = async () => {
  try {
    const orgId = localStorage.getItem("org_instance_id");
    const service_id = localStorage.getItem("service_id");

    if (!orgId) {
      console.error("org_instance_id is missing in localStorage");
      return;
    }

    const res = await Axios.get(privacy_policy, {
      params: {
        service_instance_id: orgId,
        service_id: service_id,     
        address: true,
        settings: true,
        business_hour: true,
      },
    });

    setPolicy(res.data.results?.[0] || null);
  } catch (err) {
    console.error("Failed to fetch privacy policy", err);
  } finally {
    setLoading(false);
  }
};
  useEffect(() => {
    fetchPrivacyPolicy();
  }, [orgId,service_id]);
  if (loading) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ backgroundColor: "#f9fafb", minHeight: "100vh", py: 6 }}>
      <Container maxWidth="md">
        <Paper
          elevation={3}
          sx={{
            p: { xs: 3, md: 6 },
            borderRadius: 4,
            boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
          }}
        >
          <Typography variant="h4" fontWeight={700} gutterBottom>
            Privacy Policy
          </Typography>

          <Divider sx={{ mb: 4 }} />

            <Section >
              {policy?.node_config_data?.privacy_policy}
            </Section>
        </Paper>
      </Container>
    </Box>
  );
}